import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  title: string;
  summary: string;
  category: string;
  image: string;
  publishDate: string;
  readTime: string;
  tags: string[];
}

export default function ArticleCard({ id, title, summary, category, image, publishDate, readTime, tags }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full h-48 overflow-hidden bg-background-100">
        <img
          src={image}
          alt={title}
          title={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-2">
          <span className="px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium">
            {category}
          </span>
          <span className="text-xs text-foreground-400">{publishDate}</span>
          <span className="text-xs text-foreground-400">{readTime}阅读</span>
        </div>
        <h3 className="text-base font-medium text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
          {summary}
        </p>
        <div className="flex items-center gap-2 flex-wrap">
          {tags.slice(0, 3).map((tag) => (
            <span key={tag} className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}